/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellValueWithLinks } from "./CellValueWithLinks";
export const RecordDataWithLinks = core.serialization.record(core.serialization.string(), CellValueWithLinks);
